import i18n from '@/utils/i18n';
import PlusIcon from '@assets/icons/plus.svg';
import React, { useState } from 'react';
import { CircledIcon } from '@/components/circled-icon';
import {
  IngredientActions,
  MenuItemIngredientForm,
  MenuItemIngredientFormState,
} from './menu-item-ingredient-form';
import { LIST_MARGIN_HORIZONTAL } from '@/styles';
import { ListItem, ListItemSeparator } from '@/components/list-item';
import { MICRO_CONVERSION } from '@/utils/money';
import { PackUnit } from '@/enums';
import { StyleSheet } from 'react-native';
import { useMenuInfoContext } from '@/contexts/menu-info-context';

const MANUAL_INGREDIENT_LIST_ITEM_HEIGHT = 56;

interface Props {
  initialName: string;
  menuItemUUID: string;
  onSubmit: (action: 'add' | 'remove') => void;
}

export const ManualIngredientListItem: React.FC<Props> = ({
  initialName,
  menuItemUUID,
  onSubmit,
}) => {
  const [showIngredientForm, setShowIngredientForm] = useState(false);
  const [ingredientName, setIngredientName] = useState(initialName);
  const { addMenuItemIngredient } = useMenuInfoContext();

  const handleFormSubmit = (formState: MenuItemIngredientFormState) => {
    const manualIngredient = {
      base_unit:
        formState.packUnit === PackUnit.Case
          ? formState.basePackUnit
          : undefined,
      cost_in_micros: Number(formState.ingredientPrice) * MICRO_CONVERSION,
      ingredient_name: formState.ingredientName,
      pack_unit: formState.packUnit,
      unit_count:
        formState.packUnit === PackUnit.Case ? formState.baseUnitCount : 1,
    };

    addMenuItemIngredient({ manualIngredient }, menuItemUUID);
    onSubmit('add');
    setShowIngredientForm(false);
  };
  return (
    <>
      <ListItem
        item={{
          title: i18n.t('add_ingredient_manual', { ingredientName }),
          value: ingredientName,
        }}
        listItemStyle={styles.manualIngredientListItem}
        onSelect={() => setShowIngredientForm((prev) => !prev)}
        renderLeftComponent={() =>
          showIngredientForm ? null : (
            <CircledIcon
              Icon={PlusIcon}
              iconHeight={20}
              iconWidth={20}
              size="small"
            />
          )
        }
      />
      {showIngredientForm ? (
        <MenuItemIngredientForm
          action={IngredientActions.ADD}
          initialIngredientName={ingredientName}
          onSubmit={handleFormSubmit}
          setIngredientName={setIngredientName}
        />
      ) : null}
      <ListItemSeparator style={styles.separator} />
    </>
  );
};

const styles = StyleSheet.create({
  manualIngredientListItem: {
    height: MANUAL_INGREDIENT_LIST_ITEM_HEIGHT,
    justifyContent: 'center',
    marginBottom: 8,
  },
  separator: {
    marginHorizontal: LIST_MARGIN_HORIZONTAL,
  },
});
